export const actionTypes = {
  GET_INFO: 'APP.LK_IP.GET_INFO',
  GET_INFO_SKIP_LOADING: 'APP.LK_IP.GET_INFO.SKIP_LOADING',
  REQUEST_SUCCESS: 'APP.LK_IP.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'APP.LK_IP.REQUEST_FAILURE',
};

export function getLkIp() {
  return {
    type: actionTypes.GET_INFO,
  };
}

export function getLkIpSkipLoading() {
  return {
    type: actionTypes.GET_INFO_SKIP_LOADING,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
